import { ApiModule } from '@core';
import type { MaxiNetSessionDatesResponse, MaxiNetSessionItem, MaxiNetSessionRoute } from '../models';

export class MaxiNetApi extends ApiModule {
  protected endpoint = '/maximap/corrigo';

  public getSessions(dateFrom: string, dateTo: string) {
    return this.api.get<MaxiNetSessionItem[]>(`${this.endpoint}/session`, {
      params: { dateFrom, dateTo }
    });
  }

  public getSessionDates(dateFrom: string, dateTo: string) {
    return this.api.get<MaxiNetSessionDatesResponse>(`${this.endpoint}/session-dates`, {
      params: { dateFrom, dateTo }
    });
  }

  public getSession(id: number) {
    return this.api.get<MaxiNetSessionRoute>(`${this.endpoint}/session/${id}`);
  }
}
